/**
Author - Brijesh Pandey
Git - https://github.com/brijesh-pandey
**/

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import SafeLink from "components/commons/SafeLink";

import {WealthyEnv} from "helpers";

import {
  AppDownload,
  FeaturesBar,
  LinkToKyc,
  OtpVerification,
  PinVerification,
  UserCredentials,
  ForgotPassword
} from "./components";
import {loader} from "./components/styledElements";
import {colors} from "nxtconstants";

const closeIcon = `url(${WealthyEnv.HOMEPAGE_CDN_URL}/cross-button-transparent.svg)`;
const playStoreButton = `${WealthyEnv.CDN_URL}/phoenix/play-store-button.png`;
const appStoreButton = `${WealthyEnv.CDN_URL}/articles/app-store-icon.svg`;

const propTypes = {
  // authRes: PropTypes.object,
  formData: PropTypes.object,
  isLoading: PropTypes.bool,
  rCode: PropTypes.string,
  resetPin: PropTypes.bool,
  // setAuthRes: PropTypes.func,
  rsessionId: PropTypes.string,
  setFormData: PropTypes.func,
  setIsLoading: PropTypes.func,
  setRsessionId: PropTypes.func,
  setToggleModal: PropTypes.func,
  setUserData: PropTypes.func,
  setUserStep: PropTypes.func,
  toggleModal: PropTypes.bool,
  userData: PropTypes.object,
  userStep: PropTypes.number
};

const GetStartedModal = ({
  userData,
  setUserData,
  // authRes,
  resetPin,
  toggleModal,
  rsessionId,
  setRsessionId,
  // setAuthRes,
  setToggleModal,
  setUserStep,
  userStep,
  isLoading,
  setIsLoading,
  rCode,
  formData,
  setFormData,
  inputType,
  setInputType
}) => {
  return (
    <ModalOverlay className={toggleModal ? "toggled" : ""}>
      <ModalContent>
        <CloseButton onClick={() => setToggleModal(!toggleModal)} />
        <AppDownload />
        <FormWrapper>
          {
            isLoading ? (
              <Loader />
            ) : (
              <>
                {(userStep === 1 || userStep === 2) && (
                  <UserCredentials
                    isLoading={isLoading}
                    rCode={rCode}
                    resetPin={resetPin}
                    setIsLoading={setIsLoading}
                    setRsessionId={setRsessionId}
                    setToggleModal={setToggleModal}
                    setUserData={setUserData}
                    setUserStep={setUserStep}
                    toggleModal={toggleModal}
                    userData={userData}
                    userStep={userStep}
                    formData={formData}
                    setFormData={setFormData}
                    inputType={inputType}
                    setInputType={setInputType}
                  />
                )}
                {/* {userStep === 2 && (
                  <OtpVerification
                    // authRes={authRes}
                    rsessionId={rsessionId}
                    setIsLoading={setIsLoading}
                    setRsessionId={setRsessionId}
                    setToggleModal={setToggleModal}
                    setUserStep={setUserStep}
                    toggleModal={toggleModal}
                    // setAuthRes={setAuthRes}
                    userData={userData}
                  />
                )} */}

                {userStep === 3 && (
                  <PinVerification
                    // authRes={authRes}
                    rsessionId={rsessionId}
                    // setAuthRes={setAuthRes}
                    setIsLoading={setIsLoading}
                    setUserStep={setUserStep}
                  />
                )}
                {
                  userStep === 4 && (
                    <ForgotPassword
                      setUserStep={setUserStep}
                      userData={userData}
                    />
                  )
                }

                {userStep === 5 && (
                  <LinkToKyc />
                )}
              </>
            )
          }
          <OrAppDownload>
            <Bar />
            <Text>OR</Text>
            <Bar />
          </OrAppDownload>
          <AppLinks>
            <AppLinkItem href={WealthyEnv.PARTNER_APP_NEW_APPSTORE_LINK}>
              <LinkImage
                alt="google-play"
                src={appStoreButton}
              />
            </AppLinkItem>
            <AppLinkItem href={WealthyEnv.WEALTHY_PARTNERS_APP_LINK}>
              <LinkImage
                alt="app-store"
                src={playStoreButton}
              />
            </AppLinkItem>
          </AppLinks>

          {/* <FeaturesBar /> */}
        </FormWrapper>
      </ModalContent>
    </ModalOverlay>
  );
};

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0s linear 0.3s;
  z-index: 999;

  &.toggled {
    opacity: 1;
    visibility: visible;
    transition: opacity 0.3s ease;

    & > div {
      animation: slideDown 0.3s ease;

      @keyframes slideDown {
        0% {
          transform: translateY(-100%);
        }
        100% {
          transform: translateY(0);
        }
      }
    }
  }
`;

const ModalContent = styled.div`
  background-color: #fff;
  border-radius: 24px;
  overflow: hidden;
  width: 950px;
  position: relative;
  display: flex;

  @media (max-width: 768px) {
    height: 100vh;
    width: 100%;
    min-width: 340px;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  height: 16px;
  width: 16px;
  border-radius: 100%;
  border: 0;
  outline: 0;
  background-image: ${closeIcon};
  background-color: transparent;
  background-size: contain;
  cursor: pointer;

  @media (max-width: 768px) {
    top: 65px;
    right: 30px;
    height: 18px;
    width: 18px;
  }
`;

const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 55%;

  @media (max-width: 768px) {
    min-height: 40rem;
    width: 100%;
    height: 100vh;
  }
`;

const Loader = styled(loader)``;

const OrAppDownload = styled.div`
  display: flex;
  align-items: center;
  padding: 0 4rem;
  margin-top: 2.5rem;

  @media (min-width: 769px) {
    display: none;
  }
`;

const Bar = styled.span`
  display: block;
  flex: 1;
  height: 1px;
  background: ${colors.textGray};
`;

const Text = styled.span`
  display: block;
  font-size: 1.6rem;
  color: ${colors.textGray};
  padding: 0 1rem;
`;

const AppLinks = styled.div`
  display: none;
  margin: 3rem auto;
  text-align: center;

  @media (max-width: 768px) {
    display: block;
  }
`;

const AppLinkItem = styled(SafeLink)`
  display: inline-block;

  &:not(:last-child) {
    margin-right: 20px;
    @media (max-width: 576px) {
      margin-right: 20px;
    }
  }
`;

const LinkImage = styled.img`
  height: 38px;
`;

GetStartedModal.propTypes = propTypes;

export default GetStartedModal;
